import { render, staticRenderFns } from "./CampaignDatesForm.vue?vue&type=template&id=77081117&"
import script from "./CampaignDatesForm.vue?vue&type=script&lang=js&"
export * from "./CampaignDatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports